import ContentTypeTag from 'pages/Playlists/components/AddContent/ContentTypeTag';
import { COLLECTION_EMPTY_LABEL, COLLECTION_LABS_TITLE } from 'constants/playlists';
import {
  GroupContainer,
  GroupContent,
  GroupContentTagWrapper,
  GroupItemTitle,
  GroupRow,
  GroupRowLeftWrapper,
  GroupTitle,
  LearningPathDetailContainer,
} from '../LearningPath/styles';
import { IPlaylistCollectionLab } from 'contexts/playlists/types';
import { getEligibleCollectionLabs } from 'utils/collectionLabs';

interface ICollectionDetailProps {
  data: any;
}

const CollectionDetail = ({ data }: ICollectionDetailProps): JSX.Element => {
  // Eligible labs only -- this list sits directly under the "N labs · M flags"
  // summary, which the API already counts over published labs.
  const labs = getEligibleCollectionLabs<IPlaylistCollectionLab>(data?.labs ?? []);

  return (
    <LearningPathDetailContainer>
      <GroupContainer>
        <GroupTitle>{COLLECTION_LABS_TITLE}</GroupTitle>
        <GroupContent>
          {labs.length ? (
            labs.map((lab, index) => (
              <GroupRow key={lab.uuid ?? index}>
                <GroupRowLeftWrapper>
                  <GroupContentTagWrapper>
                    <ContentTypeTag
                      value="lab"
                      variant="icon"
                      is_lab_experience
                      is_trackable={lab.has_flags}
                    />
                  </GroupContentTagWrapper>
                  <GroupItemTitle>{lab.name}</GroupItemTitle>
                </GroupRowLeftWrapper>
              </GroupRow>
            ))
          ) : (
            <GroupRow>
              <GroupRowLeftWrapper>
                <GroupItemTitle>{COLLECTION_EMPTY_LABEL}</GroupItemTitle>
              </GroupRowLeftWrapper>
            </GroupRow>
          )}
        </GroupContent>
      </GroupContainer>
    </LearningPathDetailContainer>
  );
};

export default CollectionDetail;
